<p-overlayPanel #panel [style]="{'margin-top': '60px'}" >
    <div class="group">
        <div class="collapse-title" >Icons Reference</div>
        <div class="collapse in show" id="iconsReference" #ele>
            <div class="group-cont">
                <div class="table-responsive">
                    <table class="table editable" id="history-table">
                        <thead>
                            <tr>
                                <th style="text-align: center;">Icon</th>
                                <th>Reference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <span><i class="sector la la-bank"></i></span>
                                </td>
                                <td>
                                    Banking Sector                
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-graduation-cap"></i></span>
                                </td>
                                <td>
                                    Education Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-building"></i></span>
                                </td>
                                <td>
                                    Public Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-wifi"></i></span>
                                </td>
                                <td>
                                    Telco Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-user-secret"></i></span>
                                </td>
                                <td>
                                    Security Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-briefcase"></i></span>
                                </td>
                                <td>
                                    Defense Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-angle-double-left"></i></span>
                                </td>
                                <td>
                                    Western Region Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span><i class="sector la la-angle-double-right"></i></span>
                                </td>
                                <td>
                                    Eastern Region Sector
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="status won"></span>
                                </td>
                                <td>
                                    Won Status
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="status active"></span>
                                </td>
                                <td>
                                    Active Status (Prospecting, Validating, Qualifying, Negotiating) 
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="status canceled"></span>
                                </td>
                                <td>
                                    Canceled Status
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="status lost"></span>
                                </td>
                                <td>
                                    Lost Status
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="status closed"></span>
                                </td>
                                <td>
                                    Closed Status
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</p-overlayPanel> 